import React from 'react';
import './Politica.css';

const Politica = () => {
  return (
    <div className="politica-container">
      <div className="politica-content">
        <h1>Politica de confidențialitate</h1>

        <p>
          <strong>Consimțământ</strong> – reprezintă exprimarea fără echivoc a voinței persoanei vizate, 
          în mod voluntar, sub forma unei declarații în scris sau a selectării unei rubrici speciale în 
          cazul formularelor online, prin care aceasta indică faptul că este de acord cu prelucrarea 
          propriilor date cu caracter personal.
        </p>

        <p>
          <strong>Date personale sau date cu caracter personal</strong> – orice informație referitoare 
          la o persoană fizică identificată sau identificabilă. O persoană fizică este considerată a fi 
          identificabilă atunci când poate fi identificată, direct sau indirect, prin asocierea cu cel 
          puțin unul dintre următoarele informații: nume, email, telefon, cod numeric personal, serie 
          de buletin, data nașterii, date despre locație, un identificator online sau unul sau mai multe 
          caracteristici speciale etc.
        </p>

        <p>
          <strong>Operator date</strong> – este entitatea responsabilă cu prelucrarea datelor – persoana 
          fizică sau juridică, autoritatea publică, instituția sau organismul care, singur sau împreună 
          cu alții, decide cu privire la scopurile și mijloacele de prelucrare a datelor cu caracter personal.
        </p>

        <p>
          <strong>Persoana vizată</strong> – este orice persoană fizică identificată sau identificabilă 
          ale cărei date cu caracter personal sunt prelucrate de către operator.
        </p>

        <p>
          <strong>Prelucrare date</strong> – se referă la orice proces sau serie de operațiuni efectuate 
          cu sau fără ajutorul procedeelor automatizate, legate de datele cu caracter personal, cum ar fi 
          colectarea, înregistrarea, organizarea, ordonarea, stocarea, adaptarea sau modificarea, citirea, 
          interogarea, utilizarea, divulgarea prin transmitere, distribuirea sau alta formă de punere la 
          dispoziție, restricționarea, ștergerea sau distrugerea.
        </p>

        <p>
          <strong>Terț</strong> – este o persoană fizică sau juridică, autoritate publică, instituție sau 
          o altă entitate, alta decât persoana vizată, operatorul, persoana împuternicită de operator sau 
          a persoanelor care se află în responsabilitatea nemijlocită a operatorului sau a persoanei 
          împuternicite de operator, în vederea prelucrării datelor cu caracter personal.
        </p>

        <h2>Ce informații colectăm și de ce le colectăm</h2>

        <p>
          Prin intermediul acestui website, colectăm mai multe tipuri de informații și date, prin trei 
          modalități distincte: direct de la utilizator, din rapoartele traficului înregistrat de serverele 
          care găzduiesc site-ul nostru și prin intermediul cookie-urilor.
        </p>

        <h3>Informațiile furnizate direct de utilizator:</h3>

        <p>
          Solicităm și colectăm date personale precum nume și prenume, adresă de email și/sau număr de 
          telefon furnizate atunci când completezi formularul de contact direct pe site-ul nostru. Aceste 
          date le folosim pentru a-ți putea răspunde pe email sau telefonic la mesajul primit de la tine 
          și a-ți furniza informații suplimentare privind serviciile de care ai nevoie.
        </p>

        <p>
          Solicităm și colectăm date personale precum nume și prenume, adresă, număr de telefon, adresă 
          de email și date de facturare pentru a ne putea îndeplini obligațiile contractuale.
        </p>

        <p>
          Când lași comentarii pe site, colectăm datele solicitate și arătate în formularul respectiv, 
          dar și adresa IP și șirul agenților utilizator din navigator pentru a ne ajuta la detectarea 
          spam-ului. În această situație, nu e obligatoriu să folosești numele real sau complet, iar adresa 
          de email furnizată nu va fi publicată pe site. Un șir făcut anonim (numit și un hash), creat din 
          adresele tale de email, poate fi furnizat serviciului Gravatar pentru a vedea dacă îl folosești. 
          Politica de confidențialitate a serviciului Gravatar este disponibilă aici. După aprobarea 
          comentariului, fotografia ta de profil este vizibilă pentru public lângă comentariul tău.
        </p>

        <p>
          Te asigurăm că vom stoca datele tale personale în siguranță pe serverul nostru sau pe platformele 
          de email folosite.
        </p>

        <h3>Informații din raportul de trafic al serverului:</h3>

        <p>
          Atunci când accesezi un site web, aceasta presupune furnizarea automată a unor informații ca: 
          adresa IP, ora vizitei, locul de unde ai intrat, dispozitivul folosit, tipul și versiunea 
          browser-ului folosit, sistemul de operare sau platforma folosită. Înregistrăm și stocăm aceste 
          informații pentru o perioadă determinată de timp. În acest sens, utilizăm servicii externe – 
          Google Analytics, Google Search Console – doar în scopul analizei și comunicării șabloanelor 
          tipizate anonime ale utilizatorilor. Nu folosim datele de trafic pentru identificarea persoanelor 
          din spatele unor adrese IP.
        </p>

        <h3>Informații provenite prin intermediul cookie-urilor:</h3>

        <p>
          Cookie-urile sunt fișiere de tip ".txt", oferite browserului folosit de utilizator de un server 
          web și stocate apoi pe dispozitivul folosit pentru accesarea site-ului. Folosirea cookie-urilor 
          este un standard actual folosit de majoritatea site-urilor pe care le vizitați.
        </p>

        <p>
          Majoritatea browserelor sunt setate să accepte cookie-uri. Cookie-urile ne permit, de exemplu, 
          să salvăm datele completate într-un formular astfel încât să nu fii nevoit/ă să le introduci din 
          nou data viitoare când ne vizitezi și dorești să ne contactezi prin intermediul unui formular. 
          Dacă însă nu dorești acest lucru, există posibilitatea de a reseta browserul, de a fi notificat 
          sau chiar de a refuza utilizarea cookie-urilor.
        </p>

        <p>
          Website-ul nostru folosește cookie-uri pentru a putea face diferența între diverși utilizatori 
          ce ne-au vizitat pagina în vederea posibilității de a oferi servicii personalizate acestora.
        </p>

        <h2>Cookie-uri</h2>

        <p>
          Dacă lași un comentariu pe site-ul nostru, poți opta pentru salvarea în cookie-uri a numelui, 
          adresei de email și a site-ului tău web. Acestea sunt pentru confortul tău, astfel nu mai trebuie 
          să le completezi din nou când lași un alt comentariu. Aceste cookie-uri vor fi valabile un an.
        </p>

        <p>
          Când te autentifici, vom seta și câteva cookie-uri pentru a-ți salva informațiile de autentificare 
          și opțiunile de afișare pe ecran. Cookie-urile de autentificare sunt păstrate două zile, iar cele 
          pentru opțiuni de afișare pe ecran sunt păstrate un an. Dacă selectezi "Ține-mă minte", cookie-urile 
          tale de autentificare vor fi păstrate două săptămâni. Dacă te dezautentifici din cont, cookie-urile 
          de autentificare vor fi eliminate.
        </p>

        <h2>Conținut inglobat de pe alte site-uri web</h2>

        <p>
          Articolele din acest site pot include conținut inglobat (de exemplu, video-uri, imagini, articole 
          etc.) sau pot face trimitere spre alte website-uri. Conținutul inglobat de pe alte site-uri web se 
          comportă exact la fel ca și cum vizitatorii au vizualizat un alt site web.
        </p>

        <p>
          Aceste site-uri web pot să colecteze date despre tine, să folosească cookie-uri, să inglobeze 
          urmărirea suplimentară de la părți terțe și să-ți monitorizeze interacțiunea cu conținutul inglobat, 
          inclusiv să-ți urmărească interacțiunea cu conținutul inglobat dacă ai un cont și ești autentificat 
          în acel site web.
        </p>

        <p>
          Fiecare dintre aceste pagini web are propria politică de confidențialitate și nu ne asumăm 
          răspunderea pentru conformitatea cu aceste politici. Te rugăm să verifici mai întâi care este 
          politica lor de confidențialitate înainte să le furnizezi datele personale.
        </p>

        <h2>Pentru ce anume folosim informațiile colectate?</h2>

        <p>Vom folosi datele colectate pentru:</p>

        <ul>
          <li>
            Îndeplinirea obligațiilor contractuale venite în urma încheierii unor contracte de formare între 
            persoana vizată și noi furnizori de servicii, pentru a-i oferi acesteia informațiile sau serviciile cerute;
          </li>
          <li>
            Îmbunătățirea continuă a informațiilor și conținutului de pe pagina noastră web într-un mod cât mai 
            eficient pentru utilizatori;
          </li>
          <li>
            Administrarea paginii noastre web și a operațiunilor interne aferente precum cele de troubleshooting, 
            analiză de date, testare, investigații sau în scop statistic;
          </li>
          <li>
            În măsura în care vei dori, vei putea lua parte la unele caracteristici interactive ale serviciilor noastre;
          </li>
          <li>
            Păstrarea condițiilor de securitate și siguranță atunci când navighezi pe pagina noastră web.
          </li>
        </ul>

        <h2>Cu cine partajăm datele tale</h2>

        <p>Te asigurăm că nu vindem datele tale personale unor terțe părți.</p>

        <h2>Cât timp îți păstrăm datele</h2>

        <p>
          În cazul în care datele personale trebuie să fie salvate și procesate pentru a putea îndeplini diverse 
          relații contractuale, datele vor fi păstrate doar pentru perioada de timp necesară pentru a efectua 
          serviciul în legătură cu datele care au fost colectate sau, după caz, atât cât au fost prevăzute în contract.
        </p>

        <p>
          Dacă lași un comentariu, comentariul și metadatele lui sunt păstrate pe o perioadă nedeterminată. Așa 
          putem recunoaște și aproba automat toate comentariile următoare în loc să le ținem într-o coadă pentru moderare.
        </p>

        <p>
          Indiferent de situație, vom trata aceste date confidențial și le vom utiliza numai conform legislației 
          privind protecția datelor, precum și în scopul pentru care au fost solicitate.
        </p>

        <h2>Ce drepturi ai asupra datelor tale</h2>

        <p>
          Dacă ai un cont sau ai lăsat comentarii pe acest site web, poți cere să primești un fișier de export cu 
          datele personale pe care le deținem despre tine, inclusiv toate datele pe care ni le-ai furnizat. De 
          asemenea, ne poți cere să ștergem toate datele personale pe care le deținem despre tine. Acestea nu includ 
          toate datele pe care suntem obligați să le păstrăm în scopuri administrative, juridice sau de securitate.
        </p>

        <p>
          Ai dreptul să ne ceri să nu-ți procesăm deloc datele personale. Te vom informa de ce trebuie să colectăm 
          aceste date sau dacă suntem nevoiți să dezvăluim datele tale unor terțe părți (vezi mai sus în ce situații). 
          Poți să-ți exerciți dreptul de a ne cere să nu îți procesăm datele prin marcarea unor casete în formularele 
          folosite pentru colectarea acestor date sau poți oricând să ne ceri lucrul acesta.
        </p>

        <h2>Schimbări privind politica de confidențialitate</h2>

        <p>
          Orice schimbare survenită în politica noastră de confidențialitate va fi publicată pe această pagină sau, 
          unde este cazul, notificată prin email. Te rugăm să verifici frecvent această secțiune pentru a fi la curent 
          cu eventualele schimbări.
        </p>
      </div>
    </div>
  );
};

export default Politica;